

import Vue from 'vue';
import { Component, Model, Prop, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { TableHeaderModel, SelectModel, SelectBoolModel, SelectNumberModel } from  '@/models/repsol-template.model';
import moment from 'moment';
import i18n from '@/plugins/i18n';
import { userIdentity } from '@/store/userIdentity';
import { tUi } from '@/utils/translate';

const httpStore = namespace('httpStore');

type DataTableOptions = {
  page: number;
  itemsPerPage: number;
  sortBy: string[];
  sortDesc: boolean[];
  groupBy?: string[];
  groupDesc?: boolean[];
  multiSort?: boolean;
  mustSort?: boolean;
};

@Component({
    name: 'RepsolTableComponent',
    components: {
            }
})

class RepsolTableComponent extends Vue {
    @httpStore.Action
    post!: (payload: any) => Promise<any>;

    @Prop()
    items:any[];

    @Prop()
    tableHeaders:TableHeaderModel[];

    // NEW: server-side helpers
  @Prop({ type: Number, default: 0 })
  serverItemsLength!: number;

  @Prop({ type: Boolean, default: false })
  loading!: boolean;

    get resolvedServerItemsLength(): number {
        if (this.serverItemsLength && this.serverItemsLength > 0) {
            return this.serverItemsLength;
        }
        if (Array.isArray(this.items)) {
            return this.items.length;
        }
        return 0;
    }

  // NEW: options used by v-data-table-server
  options: DataTableOptions = {
    page: 1,
    itemsPerPage: 10,
    sortBy: [],
    sortDesc: [],
  };

    @Watch('tableHeaders')
    changeHeaders(): void {
        if(this.tableHeaders.length > 0){
            this.tableHeaders.map(item => {
                item.sort = this.customSortFn(item.as, item.items);
            })
        }
    }
    collapsed = true;
    filterColumn:any = {};

    get tableHeadersFilter(){
        // Make header/filter translations recompute on locale switch.
        const currentLocale = this.$i18n.locale;
        void currentLocale;

        if(!this.tableHeaders) return this.tableHeaders;
        return this.tableHeaders.map(th => {
            return {
                ...th,
                text: tUi(th.text),
                filter: (value: string, query: string, item?: any) =>  this.filterFunction(th, value, query, item)
            };
        });
    }
    get tableHeaderActions() {
        if(!this.tableHeaders) return [];
        const th = this.tableHeaders.find(th => th.value == 'actions');
        if(th && th.actions)
            return th.actions;
        return [];
    }

    get footerProps() {
        return {
            itemsPerPageOptions: [5, 10, 15, 100],
            showFirstLastPage: true,
            itemsPerPageText: i18n.t('table.items_per_page_text').toString(),
            pageText: i18n.t('table.page_text').toString(),
        };
    }

    // NEW: emit when pagination/sort changes
    onOptionsChanged(newOptions: DataTableOptions) {
    this.options = newOptions;
    this.$emit('options-changed', newOptions);
    }

    customSortFn(type:any, items:any) {
            switch(type){
                case 'selectlist':
                case 'select':
                case 'multiselect':
                    return (a:any, b:any) => {
                        const aStr = this.format(a, type, items);
                        const bStr = this.format(b, type, items);
                        return aStr == bStr ? 0 : aStr < bStr ? -1 : 1;
                    };
                default:
                    return (a:any, b:any) => {
                        return a == b ? 0 : a < b ? -1 : 1;
                    };
            }
    }

    filterFunction(tableHeader:TableHeaderModel, value: any, query: string, item?: any) : boolean{
        var result = true;

        switch (tableHeader.as) {
            case 'text':
                var textFilter = this.filterColumn[tableHeader.value];
                if(textFilter)
                    result = value.toLowerCase().indexOf(textFilter.toLowerCase()) !== -1;
                break;
            case 'number':
                var minValue = this.filterColumn[tableHeader.value + "-min"];
                var maxValue = this.filterColumn[tableHeader.value + "-max"];
                result = (minValue == undefined || minValue == '' || Number(minValue)<=Number(value))
                && (maxValue == undefined || maxValue == '' || Number(maxValue)>=Number(value));
                break;
            case 'select':
            case 'selectlist':
                var selectItem = this.filterColumn[tableHeader.value];
                if(selectItem != null && selectItem != undefined)
                    result = value === selectItem;
                break;
            case 'multiselect':
                var selectItems = this.filterColumn[tableHeader.value];

                if(selectItems && selectItems.length > 0)
                    result = (selectItems as SelectModel[]).some(fv => value == fv.id);
                break;
            case 'date':
                var minDate = this.filterColumn[tableHeader.value + "-min"];
                var maxDate = this.filterColumn[tableHeader.value + "-max"];

                result = (minDate == undefined || minDate == '' || new Date(minDate)<=new Date(value))
                && (maxDate == undefined || maxDate == '' || new Date(maxDate) >= new Date(value));
                break;
            default:
                break;
        }

        return result;
    }

    tieneTooltip(value, {maxLen, tooltip}){
        return tooltip || (maxLen && maxLen > 0 && value && value.length > maxLen);
    }

    textTooltip(value, {maxLen}){
        var text = maxLen && maxLen > 0 ? value.substring(0, maxLen) + '...' :value.toUpperCase();
        console.log("text tooltip", maxLen, value, text);
        return text;
    }

    format(value, type, items): string{
        if (value != null && value != undefined) {
            if(items){
                if(Array.isArray(value)){
                    var nombres = value.map(v => this.getSelectNombre(v, items));
                    return nombres.join('/ ');
                } else {
                    var item = items.find(i => i.id == value);
                    if(item) {
                        return this.translateUserProfileValue(value, item.nombre);
                    }
                }
            }else{
                switch(type) {
                    case "date":
                        return moment(value).format("DD/MM/YYYY");
                    case "dateTime":
                      console.log("datetime", value, moment(value))
                        return moment(value).format("DD/MM/YYYY hh:mm");
                    default: return tUi(String(value));
                }
            }
        }
        return value;
    }


    getSelectValue(tableHeader:TableHeaderModel): SelectModel[]{
        if(!this.items) return [];
        let values = this.items.map(i => i[tableHeader.value]);
        let unique = [...new Set(values)];

        let response:SelectModel[] = [];
        unique.forEach(u => {
            if(u != null && u  != undefined){
                response.push({id: u, nombre: this.getSelectNombre(u, tableHeader.items), soloLectura: true});
            }
        });

        return response;
    }

    getSelectNombre(id:any,items?:SelectModel[]|SelectBoolModel[]|SelectNumberModel[]) : string{
        if(!items)
            return this.translateUserProfileValue(id, id);

        for (let i = 0; i < items.length; i++) {
            if(items[i].id === id){
                return this.translateUserProfileValue(id, items[i].nombre);
            }
        }

        return this.translateUserProfileValue(id, id);
    }

    translateUserProfileValue(profileId: any, profileName: any): string {
        const id = String(profileId ?? '').trim().toUpperCase();
        const name = String(profileName ?? '').trim().toLowerCase();

        if (id === 'ADM' || name === 'administrador' || name === 'administrator') {
            return tUi('usuarios.profile_admin');
        }

        if (id === 'MESA' || name === 'operador mesa' || name === 'desk operator') {
            return tUi('usuarios.profile_desk_operator');
        }

        if (id === 'MLECT' || name === 'operador mesa lectura' || name === 'desk read-only operator') {
            return tUi('usuarios.profile_desk_readonly_operator');
        }

        if (id === 'CONTR' || name === 'operador contraparte' || name === 'counterparty operator') {
            return tUi('usuarios.profile_counterparty_operator');
        }

        if (id === 'CEN' || name === 'administrador central' || name === 'central administrator' || name === 'central') {
            return tUi('usuarios.profile_central_admin');
        }

        if (id === 'DER' || id === 'DERIV' || name === 'operador derivados' || name === 'derivatives operator') {
            return tUi('usuarios.profile_derivatives_operator');
        }

        if (id === 'DERL' || id === 'DERIVL' || name === 'operador derivados lectura' || name === 'derivatives read only operator') {
            return tUi('usuarios.profile_derivatives_readonly_operator');
        }

        return tUi(String(profileName));
    }

    eventAction(action:string, item:any){
        this.$emit("eventAction", action, item);
    }

    eventDrop() {
        this.collapsed = !this.collapsed;
    }

    async descargarTablaComoCSV() {
        const listeners = (this as any).$listeners;

        if (listeners && listeners.exportar) {
            this.$emit("exportar");
            return;
        }

        if(!this.tableHeaders) return;

        const headers = this.tableHeadersFilter.filter(th => th.value != 'actions' && !th.noExportable);

        let excelData = [headers.map(th => th.text)];

        this.items.forEach(i => {
            var row :string[]= [];
            headers.forEach(th => {
                const formattedValue = this.format(i[th.value], th.as, th.items);
                row.push(formattedValue === null || formattedValue === undefined ? '' : String(formattedValue));
            });
            excelData.push(row);
        });

        let route = '/api/excel/export?filename=tabla.xlsx';

        this.post({ apiUrl: route, entity: excelData, array: true }).then(data => {
            let blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'table.xlsx');
            document.body.appendChild(link);
            link.click();
        });

        return;
    }
}

export default RepsolTableComponent;
Vue.component('repsol-table', RepsolTableComponent);
